/**
 * TrackingPanel — Step 16 rich detail.
 *
 * Carrier + tracking number + waybill upload + ETA, plus a Stepper
 * milestone strip showing where the goods physically are right now.
 */
import React from 'react';
import { Package, ExternalLink, FileUp } from 'lucide-react';
import Stepper from './Stepper';

const DEFAULT_MILESTONES = [
  { key: 'pickup',     label: 'Picked up',      done: false },
  { key: 'in_transit', label: 'In transit',     done: false },
  { key: 'customs',    label: 'Customs',        done: false },
  { key: 'released',   label: 'Released',       done: false },
  { key: 'delivered',  label: 'Delivered',      done: false },
];

const TrackingPanel = ({ order }) => {
  const t = order.tracking;
  const milestones = t?.milestones || DEFAULT_MILESTONES;

  return (
    <div className="manifest-rich-panel manifest-tracking">
      <div className="manifest-rich-panel-head">
        <div className="manifest-rich-panel-title">
          <Package size={16} /> Shipment tracking
        </div>
      </div>

      <div className="manifest-tracking-grid">
        <div className="manifest-tracking-field">
          <label>Carrier</label>
          <div>{t?.carrier || '— pending pickup —'}</div>
        </div>
        <div className="manifest-tracking-field">
          <label>Tracking number</label>
          <div className="manifest-tracking-num">
            {t?.trackingNumber ? (
              <>
                {t.trackingNumber}
                <ExternalLink size={11} className="manifest-tracking-link" />
              </>
            ) : '—'}
          </div>
        </div>
        <div className="manifest-tracking-field">
          <label>ETA</label>
          <div>
            {t?.eta
              ? new Date(t.eta).toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' })
              : '—'}
          </div>
        </div>
        <div className="manifest-tracking-field">
          <label>Waybill</label>
          <div>
            {t?.waybillUrl ? (
              <a href={t.waybillUrl} target="_blank" rel="noreferrer">View waybill</a>
            ) : (
              <button className="manifest-btn-ghost-sm"><FileUp size={11} /> Upload</button>
            )}
          </div>
        </div>
      </div>

      <Stepper steps={milestones} />
    </div>
  );
};

export default TrackingPanel;
